<div class="chart-info-dialog">
    <div class="dialog-header">
      <h2>Forces et faiblesses</h2>
      <app-icon type="close" (click)="close()" class="close-icon"></app-icon>
    </div>
    
    <div class="dialog-content">
      <div class="axes-list">
        <div *ngFor="let axis of chartAxesDescriptions" class="axis-item">
          <h3>{{ axis.title }}</h3>
          <p>{{ axis.description }}</p>
        </div>
      </div>
    </div>
  </div>